import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;

  @media (max-width: 768px) {
    height: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding-left: 50px;

  @media (max-width: 768px) {
    width: 80%;
    padding-left: 0;
    order: 1;
    padding-bottom: 100px;
  }
`;

export const Title = styled.h2`
  font-size: 50px;
  color: white;
  font-weight: bold;
  line-height: 50px;

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 36px;
  }
`;

export const Subtitle = styled.span`
  padding-top: 20px;

  @media (max-width: 768px) {
    padding-bottom: 20px;
  }
`;

export const HelpCenter = styled.a`
  color: white;
  text-decoration: underline;
`;
